import { GeneralAlertTriangleOutlineIcon, Selector } from '@outdoorsyco/bonfire';
import { useIntl } from 'react-intl';

type TDeclineInsuranceProps = {
  insuranceIsDeclined?: boolean;
  onDeclineInsurance?: () => void;
};

export const DeclineInsurance = ({
  insuranceIsDeclined = false,
  onDeclineInsurance,
}: TDeclineInsuranceProps) => {
  const intl = useIntl();

  if (!onDeclineInsurance) return null;

  return (
    <Selector
      isSelected={insuranceIsDeclined}
      icon={GeneralAlertTriangleOutlineIcon}
      ariaLabel={intl.formatMessage({ defaultMessage: 'Decline Insurance', id: 'kDYAHs' })}
      label={intl.formatMessage({ defaultMessage: 'Decline Insurance', id: 'kDYAHs' })}
      description={intl.formatMessage({
        defaultMessage: `High risk - You will be liable for any incident or damage to the vehicle. Don't assume you'll be covered by your personal insurance or credit card.`,
        id: '3Z4yZr',
      })}
      name="decline-insurance"
      onChange={onDeclineInsurance}
      value="add-trip-protection"
      labelClassName="text-red-600"
      contentWrapperClassName={insuranceIsDeclined ? '!bg-red-600/30' : ''}
      showIndicator
      withBorder
    />
  );
};
